const React = require('react');
const PropTypes = require('prop-types');
const APIRequest = require('components/api_request.js');
const UrlHelpers = require('components/shared/url_helpers.js');

const AutoProductBundle = require('./auto_product_bundle.jsx');

class AutoProductBundles extends React.Component {
  state = {
    bundles: [],
    mainListing: null,
  };

  componentDidMount() {
    this.fetchBundles();
  }

  get shouldRender() {
    return this.state.bundles.length > 0;
  }

  fetchBundles() {
    APIRequest.V3.get(UrlHelpers.autoProductBundlesPath(this.props.productId))
      .then((response) => {
        this.setState({
          bundles: response.bundles,
          mainListing: response.main_listing,
        });
      });
  }

  renderBundles() {
    return this.state.bundles.map(bundle =>
      (<AutoProductBundle
        mainListing={this.state.mainListing}
        bundle={bundle}
        key={bundle.discounted_listing.id}
      />));
  }

  render() {
    if (!this.shouldRender) { return null; }

    return (
      <section className="hardware-software-bundles">
        <div className="bundle-header">
          <h3 className="bundle-header__title">
            {I18n.t('js.autoProductBundles.header')}
          </h3>
        </div>
        <div className="bundle-items">
          {this.renderBundles()}
        </div>
      </section>
    );
  }
}

AutoProductBundles.propTypes = {
  productId: PropTypes.string.isRequired,
};

module.exports = AutoProductBundles;



// WEBPACK FOOTER //
// ./javascripts/components/product_show_page/auto_product_bundles.jsx